import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  Form,
  Spin,
  Col,
  Divider,
  Button,
  Modal,
  List,
} from "antd";

//PROJECT IMPORTS
import TopContent from "../../../components/layouts/TopContent";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import "../../../assets/styles/DatePicker.css";
import styles from "../../../assets/styles/styles";
import MainLayout from "../../../components/layouts/MainLayout";
import RecordStatus from "../../../components/RecordStatus";
import { apiConfig, labelConfig, staticConfig } from "../security.config";
import AssignedPermissions from "./components/AssignedPermissions";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";
const { Text, Title } = Typography;

const DetailRole = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleOnDelete = () => {
    let action = "Delete  ";
    let roleName = `${state.name}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + roleName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Roles}/${state.key}`;
        let body = {
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteRoleMsg);
              navigate("/sms0400", {
                state: { state },
              });
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/sms0400", {
                state: { state },
              });;
              setIsLoading(false);
            },
          }
        );
      },

      function () {
        // No button
      }
    );
  };

  function handleOnEnable() {
    let action = "Enable  ";
    let roleName = `${state.name}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + roleName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = {
          command: "enable",
        };
        const url = `${apiConfig.Roles}/${state.id}`;

        let body = {
          method: "POST",
          session,
          params,
          roleId: state.id,
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.enableRoleMsg);
              navigate("/sms0400", {
                state: { state },
              });
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/sms0400", {
                state: { state },
              });
              setIsLoading(false);
            },
          }
        );
      },

      function () {
        // No button
      }
    );
  }

  function handleOnDisable() {
    let action = "Disable  ";
    let roleName = `${state.name}`;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + roleName,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const params = {
          command: "disable",
        };
        const url = `${apiConfig.Roles}/${state.id}`;

        let body = {
          method: "POST",
          session,
          params,
          roleId: state.id,
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.disableRoleMsg);
              navigate("/sms0400", {
                state: { state },
              });
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/sms0400", {
                state: { state },
              });
              setIsLoading(false);
            },
          }
        );
      },

      function () {
        // No button
      }
    );
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onDelete={handleOnDelete}
      onApprove={() => handleOnEnable()}
      onReject={() => handleOnDisable()}
    >
      <TopContent
        pageTitle={labelConfig.detailRole}
        pageItems={staticConfig.detailRoleBreadrumbItems}
      />

      <AssignedPermissions roleId={state.id} state={state} />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(DetailRole);
